import { CLI_V2 } from "../../Data/typeDirs"
import { DateToFormattedString, genId } from "../../utils"


export class ClientV2{
  constructor(data = {}){
    this._id = data._id || genId()
    this.name = data.name || ''
    this.created = data.created || Date.now()
    this.modified = data.modified || this.created
    this._createdBy = data._createdBy
    this._modifiedBy = data.modifiedBy
    this.dirName = ClientV2.getNewDirName(this.name, this.created)
    this.address = data.address || {streetAddress:'', city:'', state:''}
    this.info = data.info || ''
    this.logo = data.logo || null
    this.type = ClientV2.getTypeDir()
  }

  static getNewDirName(name, created){ return `${name}-${DateToFormattedString(new Date(created), true)}` }
  static getTypeDir(){ return CLI_V2 }
  static getIndices() { return '_id,name' }

  getContents(){
    let {name, address, phoneNumber, info, logo} = this
    return [{name, address, phoneNumber, info, logo, type:'clientData', schema:'clientDataSchema'}]
  }
  
  getPhotoContents(){
    return [{logo:this.logo, type:'clientLogo', schema: 'clientLogoSchema'}]
  }

  getSchemas(){
    return [{name:'clientDataSchema', _id:genId(), content: [
      {
        name: 'root',
        type: 'Container',
        children: [
          {
            name:'nameContainer',
            type: 'Container',
            displaySettings: {as: "Row"},
            children: [ 
              {
                name: 'name',
                type: 'text',
                placeholder: 'Company Name'
              }
            ]
          }, {
            name: 'infoContainer',
            type: 'Container',
            displaySettings: {as: 'Row'},
            children: [ 
              {
                name: 'address',
                type: 'address',
                placeholder: 'Address'
              },{
                name: 'phoneNumber',
                type: 'text',
                placeholder: 'Phone Number'
              },{
                name: 'info',
                type: 'text',
                displaySettings: {as: 'textarea' },
                placeholder: 'Extra info'
              }
            ]
          }
        ]
      }
    ]}, { name: 'clientLogoSchema', _id: genId(), content:[
      { 
        name: 'root',
        type: 'Container',
        children: [
          {
            name: 'logoContainer',
            type: 'Container',
            displaySettings: {as: 'Row'},
            children: [
              {
                name: 'logo',
                placeholder: 'logo',
                type: 'image',
                options: {thumbnailSize: 'sm'}
              }
            ]
          }
        ]
      }
    ]

    }]
  }
}